export enum GroupCategory {
  /**
   * @notice 휠 + 타이어 묶음
   */
  TIRE = "타이어",
  /**
   *
   */
  ENGINE_OIL = "엔진오일",
  /**
   *
   */
  BRAKE_PAD = "브레이크패드",
  /**
   *
   */
  WIPER = "와이퍼",
  /**
   * WHEEL_ALIGNMENT
   */
  WHEEL_ALIGNMENT = "휠얼라인먼트",

  TIRE_STORAGE = "보관서비스",
}

export type GroupCategoryType = keyof typeof GroupCategory;
